<template>
  <svg
    v-bind="svgAttributes"
    class="personal-counter-progress-circle"
  >
    <circle
      v-bind="circleAttributes"
      :stroke-dashoffset="circle.end"
      :class="[
        'personal-counter-progress-circle__bar',
        'personal-counter-progress-circle__circle',
      ]"
    />
    <circle
      v-bind="circleAttributes"
      :stroke-dashoffset="progress"
      :class="[
        'personal-counter-progress-circle__circle',
        'personal-counter-progress-circle__progress',
      ]"
      data-test-id="personal-counter-progress-circle"
    />
  </svg>
</template>

<script>
export default {
  name: 'EPersonalCounterProgressCircle',
  props: {
    percentage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    circle() {
      return {
        radius: 21,
        start: 135,
        end: 58,
      };
    },
    circleAttributes() {
      const { radius, start } = this.circle;
      return {
        'cx': radius,
        'cy': radius,
        'r': radius,
        'stroke-dasharray': start,
      };
    },
    progress() {
      /* We manipulate stroke-dashoffset of green circle to show the progress which is
       * given in pixels. The arc starts at 135 and finishes at 58, so we get progress by
       * adding the percentage of the difference between end and start to the start
       */
      const { start, end } = this.circle;
      return start + (end - start) * this.percentage;
    },
    svgAttributes() {
      const { radius } = this.circle;
      const diameter = 2 * radius;
      return {
        height: diameter,
        width: diameter,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-counter-progress-circle {
  overflow: visible;
  transform: rotateZ(165deg);
}

.personal-counter-progress-circle__circle {
  fill: transparent;
  stroke-linecap: round;
  stroke-width: 2px;
}

.personal-counter-progress-circle__bar {
  stroke: var(--color-background-quaternary);
}

.dark .personal-counter-progress-circle__bar {
  stroke: var(--color-disabled);
}

.personal-counter-progress-circle__progress {
  stroke: var(--color-brand-primary);
  transition: stroke-dashoffset $timing-m;
}
</style>
